import { LIST_FAVOURITE_ERROR, LIST_FAVOURITE, ADD_FAVOURITE_ERROR, ADD_FAVOURITE_INFO } from "../types";

const initialState = {
    favouriteInfo: {},
    loading: true,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case LIST_FAVOURITE:
            return {
                ...state,
                favouriteInfo: action.payload,
                loading: false,
            };
        case LIST_FAVOURITE_ERROR:
            return {
                ...state,
                loading: true,
            };
        default:
            return state;
    }
}
